import React from 'react';
import { connect } from 'react-redux';
import Navigation from './Navigation';
import SearchBar from './SearchBar';
import Cart from './Cart';
import Wishlist from './Wishlist';
import AppTicker from './AppTicker';
import CategoryButtonMobile from '../homepage/CategoryButtonMobile';
import { getMyAccountDetails, getCartWishlistCount } from '../../../actions/homeData';
import { storageAvailable } from '../../common/storageAvailable';
import getHeaderConfigForPage from '../../../utils/headerConfig.js';
import { generateEvent } from '../../../utils/dataGrinch';
import { isServerRendering } from '../../../utils/pageInfo';
import properties from '../../../modules/ajio-util/properties';
import { replaceWithJioCDN } from '../../../utils/imageHandling';
// import { deferAppInstallBanner } from "../../../pwa/sw-activation.js";
import { getEnableCatNavSec } from '../../../Flags/selectors';
// const imageBaseUrl = properties.getProperty("imageBaseUrl");

class Header extends React.Component {
  constructor() {
    super();
    this.state = {
      childVisible: false,
      isCurrent: true,
      showCategories: false,
      collapseCategory: true,
      headerNav: true
    };
    this.showMenu = this.showMenu.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
  }

  linkClick(link, name, type = 'HeaderClick') {
    generateEvent({
      Event: type,
      value: {
        LinkName: name,
        LinkUrl: link,
        Screen: 'Mobile'
      }
    });
    // window.location = link;
  }

  expandCategory = e => {
    e.preventDefault();
    this.setState({
      showCategories: !this.state.showCategories,
      headerNav: !this.state.headerNav,
      childVisible: false,
      isCurrent: true
    });
  };

  collapseCategory = e => {
    this.setState({
      showCategories: !this.state.showCategories,
      headerNav: !this.state.headerNav
    });
  };

  showMenu() {
    this.props.getMyAccountDetails();
    this.setState({
      childVisible: !this.state.childVisible,
      isCurrent: !this.state.isCurrent
    });
    document.body.classList.toggle('noScroll');
    // deferAppInstallBanner();
  }

  hideMenu() {
    this.setState({
      childVisible: false,
      isCurrent: true
    });
    document.body.classList.remove('noScroll');
  }

  componentDidMount() {
    const { getCartWishlistCount: setCartWishlistCount } = this.props;
    setCartWishlistCount();
  }

  render() {
    const { headerNav, childVisible, isCurrent } = this.state;
    const {
      noHeaderTitle = false,
      showSearchBar = true,
      showWishlist = true,
      showCart = true,
      showSearchBlock = false,
      noHeaderButtons,
      metaData: {
        sis = false,
        name = '',
        showStoreNav = false,
        current: {
          colorTheme = '#fff',
          textColor = '#000',
          headerIconColor = '#000',
          smallerLogo = '',
          subdomain = ''
        } = {}
      } = {}
    } = this.props;
    const { catNavHeadTitles = [], pageTitleLandingPage = '', enableCatNavSec = true } = this.props;
    /**
     * Browser specific code
     */
    // if(noHeaderTitle){
    let pathname = '';
    let loginURL = '';
    if (!isServerRendering()) {
      const { location = {} } = window;
      pathname = location.pathname;
      loginURL = location.href;
    } else {
      pathname = this.props.location.path ? this.props.location.path : '';
    }

    var headTitle = pathname
      ? pathname.substring(pathname.lastIndexOf('/') + 1, pathname.length)
      : null;
    // }

    let titleName = '';
    let at = false;
    let pageType = '';
    let isGPay = false;
    let showAppTicker = false;
    if (!isServerRendering()) {
      var isLocalStorage = storageAvailable('localStorage');
      pageType = window.pageType;
      if (isLocalStorage) {
        let catName = localStorage.getItem('categoryClicked');
        titleName = localStorage.getItem('title');
      }
      at = window.sessionStorage ? window.sessionStorage.getItem('at') : false;
      isGPay = sessionStorage.getItem('gpay') === 'true';
      showAppTicker = properties.getProperty('gpayAppticker') === 'ON' && isGPay;
    }
    // let headTitle = "";
    /**
     * Browswer specific code
     */

    let config = getHeaderConfigForPage(pathname, pageType, sis);
    let regex = RegExp('/p/');

    const isLandingPage = pathname.includes('/shop');
    const iconColor = sis ? headerIconColor : '#b19975';

    return (
      <div>
        {!showAppTicker && config.includes('appticker') && !at ? (
          <AppTicker showAppTicker={config.includes('appticker')} />
        ) : (
          ''
        )}
        {this.state.showCategories && (
          <div
            className="overlay-cat-nav"
            onClick={this.collapseCategory}
            data-ga-event-category="Page Interaction"
            data-ga-event-action="buttonTap"
            data-ga-event-label="fabClose"
          >
            <div className="dropdown-catnav dropdown-transition">
              <CategoryButtonMobile
                fromPage="mobHeader"
                category={
                  !!(
                    isLocalStorage &&
                    localStorage.getItem('categoryClicked') != '' &&
                    localStorage.getItem('categoryClicked') != null
                  )
                }
              />
              <span
                className="ic-chevronup chevron-up"
                onClick={this.collapseCategory}
                data-ga-event-category="Page Interaction"
                data-ga-event-action="buttonTap"
                data-ga-event-label="fabClose"
                style={{ color: sis ? colorTheme : '#000' }}
              />
            </div>
          </div>
        )}

        <div
          className={`app-header${showStoreNav ? ' lower-z-index' : ''}${
            sis ? ' store-in-store' : ''
          }`}
        >
          {noHeaderButtons ? (
            <header>
              <div className={isCurrent ? 'ic-hamburger' : 'ic-menuopen'} onClick={this.showMenu} />
              <span className="header-text">My Account</span>
            </header>
          ) : headerNav ? (
            <header
              className={`sis-${sis}`}
              style={{
                backgroundColor: colorTheme,
                color: headerIconColor
              }}
            >
              {window && window.location && regex.test(window.location.pathname) ? (
                <div
                  className="ic-backbutton pdp-backbutton"
                  style={{ color: iconColor }}
                  onClick={() => window.history.back()}
                />
              ) : (
                <div
                  className={isCurrent ? 'ic-hamburger' : 'ic-menuopen'}
                  onClick={this.showMenu}
                  style={{ color: iconColor }}
                />
              )}
              {this.props.noHeaderTitle || sis ? (
                !sis ? (
                  <div className="fnl-logo">
                    <a href="/">
                      <div className="ic-home-logo" />
                    </a>
                  </div>
                ) : (
                  <div className="fnl-logo store-fnl-logo">
                    <a href={`http://${subdomain}`}>
                      <img src={replaceWithJioCDN(smallerLogo)} alt='header store logo' />
                    </a>
                  </div>
                )
              ) : catNavHeadTitles.lastIndexOf(headTitle) != -1 ? (
                <div className={`catnav-sec ${enableCatNavSec ? '' : 'point-none'}`}>
                  <span
                    onClick={this.expandCategory}
                    data-ga-event-category="Page Interaction"
                    data-ga-event-action="buttonTap"
                    data-ga-event-label="fabButton"
                  >
                    {headTitle || titleName || null}
                  </span>
                  {headTitle && enableCatNavSec ? (
                    <span
                      className="ic-chevrondown"
                      onClick={this.expandCategory}
                      data-ga-event-category="Page Interaction"
                      data-ga-event-action="buttonTap"
                      data-ga-event-label="fabButton"
                    />
                  ) : null}
                </div>
              ) : (
                <div className="catnav-sec catnav-sec-nochevron">
                  <span>{pageTitleLandingPage}</span>
                </div>
              )}
              {/* // comment this code as old mobile code is not used anymore */}
              {/* {isLandingPage && <span id="add-to-home-screen" onClick={()=> deferAppInstallBanner()} className="add-to-home-screen">
            <img src={imageBaseUrl + "/static/img/add-to-home-screen-btn-icon.svg"} alt="add to home screen"/>
          </span>} */}
              <div className="scb">
                {showSearchBar && <SearchBar showSearchBlock={showSearchBlock} />}
                {showWishlist && <Wishlist linkClick={this.linkClick} />}
                {showCart && <Cart linkClick={this.linkClick} />}
              </div>
            </header>
          ) : null}
          <Navigation
            className={childVisible ? 'megamenu-open' : 'megamenu-close'}
            toggleMenu={this.showMenu}
            loginURL={loginURL}
          />
          {childVisible ? <div className="nav-overlay" onClick={this.hideMenu} /> : null}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { HomeReducer = {}, banner = {}, location = {}, metaData = {}, flags = {} } = state;
  const { pageDetails = [] } = HomeReducer;
  const { pageDetails: pgDetailsBanner = [] } = banner;
  const detailsLandingPage =
    pgDetailsBanner.filter(data => {
      const { pageTitle } = data;
      if (pageTitle) {
        return true;
      }
      return false;
    })[0] || {};
  const { pageTitle = '' } = detailsLandingPage;

  const buttonCategories =
    pageDetails.filter(data => {
      const { nativeCategoryNavigationListDetails } = data;
      if (nativeCategoryNavigationListDetails) {
        return true;
      }
      return false;
    })[0] || {};
  const { nativeCategoryNavigationListDetails = [] } = buttonCategories;
  const catNavHeadTitles = nativeCategoryNavigationListDetails
    ? nativeCategoryNavigationListDetails.map((categories, indexTitle) => {
        return categories.nativeCategoryName.toLowerCase();
      })
    : null;
  return {
    catNavHeadTitles,
    pageTitleLandingPage: pageTitle,
    location,
    metaData,
    enableCatNavSec: getEnableCatNavSec(flags)
  };
}

export default Header = connect(mapStateToProps, {
  getCartWishlistCount,
  getMyAccountDetails
})(Header);
